/**
 * @flow
 */

const logger = {
  debug: (_: unknown) => {},
  info: (_: unknown) => {},
  warn: (_: unknown) => {},
  error: (_: unknown) => {},
  log: (_: unknown, __: unknown) => {},
};

window.console = logger;
